export default function processPingCommand(onCallback: any): void {
    const result = {
        gdprAppliesGlobally: true,
        cmpLoaded: true,
    };
    onCallback(result, true);
}
